import React from 'react'
import { Image, Button, Modal } from "react-bootstrap";
import {
  ModalButton,
  ModalTitle,
} from './claimNonprofitModalStyle'
import NonprofitImage from '../../../assests/images/nonprofitmimg.svg';
interface ClaimNonprofitProps {
  editClaimNonProfitOpen: boolean;
  setClaimNonprofitOpen: (val: boolean) => void;
  confirmClaim: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

const ClaimNonprofitModal: React.FC<ClaimNonprofitProps> = ({ editClaimNonProfitOpen, setClaimNonprofitOpen, confirmClaim }: any) => {
  return (
    <Modal show={editClaimNonProfitOpen} className='claim-nonprofit-modal'
      onHide={() => setClaimNonprofitOpen(false)} centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <Image src={NonprofitImage} />
        <ModalTitle>Are You Sure You want to Claim this Nonprofit?</ModalTitle>
        <ModalButton>
          <Button className='fill-btn modal-btn' onClick={confirmClaim}>Confirm</Button>
          <Button className='blank-btn modal-btn' onClick={() => setClaimNonprofitOpen(false)}>Cancel</Button>
        </ModalButton>
      </Modal.Body>
    </Modal>
  )
}

export default ClaimNonprofitModal;
